module.exports = __webpack_public_path__ + "0a76ad886bc39f8c4c4d25818da06d7d.png";